import {RfcSubmissionsList} from '@common-web/components/rfc/RfcSubmissionsList';

export function InternalRfcSubmissions() {
  return <RfcSubmissionsList getReviewHref={(id) => `/rfc/admin/${id}`} />;
}
